export type GalleryCategory = 'All' | 'Weddings' | 'Festivals & Fairs' | 'Brand Activations' | 'Decor' | 'Skins and Sidewalls' | 'Glamping';

export interface GalleryImage {
  id: number;
  category: Exclude<GalleryCategory, 'All'>;
  src: string;
  alt: string;
  title: string;
}

// Optional hand-picked lead for the "All" view: these image FILENAMES are
// hoisted to the front (in this order); everything else follows in its
// existing order. Keyed by filename so it survives id regeneration. Set via
// the lead-selector tool (scripts/gen-lead-page.mjs). Empty = no change.
export const leadOrder: string[] = [
  "festival-vendor-village-26.webp",
  "festivals-fairs-11.webp",
  "festival-vendor-village-15.webp",
  "festival-vendor-village-18.webp",
  "festival-vendor-village-24.webp",
  "festival-vendor-village-29.webp",
  "decor-22.webp",
  "a391e6deefcd.webp",
  "glamping-01.webp",
  "glamping-02.webp",
  "glamping-12.webp",
  "festival-vendor-village-11.webp",
  "9ec458b542cf.webp",
  "decor-32.webp",
  "brand-activations-05.webp",
  "brand-activations-07.webp",
  "3c8536d20984.webp",
  "cada58805478.webp",
  "651bc6ed489f.webp",
  "festivals-fairs-29.webp",
  "festivals-fairs-28.webp",
  "festivals-fairs-27.webp",
  "festival-vendor-village-25.webp",
  "events-06.webp",
  "events-07.webp",
  "festival-vendor-village-21.webp",
  "festivals-fairs-22.webp",
  "festival-vendor-village-19.webp",
  "festival-vendor-village-20.webp",
  "festival-vendor-village-16.webp",
  "festival-vendor-village-10.webp",
  "events-04.webp",
  "festival-vendor-village-09.webp",
  "festival-vendor-village-06.webp",
  "festival-vendor-village-05.webp",
  "festival-vendor-village-03.webp",
  "weddings-11.webp",
  "weddings-18.webp",
  "weddings-17.webp",
  "weddings-14.webp",
  "weddings-16.webp",
  "weddings-13.webp",
  "weddings-09.webp",
  "weddings-10.webp",
  "weddings-08.webp",
  "weddings-07.webp",
  "weddings-03.webp",
  "skins-02.webp",
  "weddings-04.webp",
  "weddings-01.webp",
];

export const galleryImages: GalleryImage[] = [

  // ── Weddings ──
  {
    id: 1,
    category: "Weddings",
    src: "/assets/img/weddings-01.webp",
    alt: "Wedding celebration under a Pop Pro Tents stretch tent",
    title: "Stretch Tent Wedding 1",
  },
  {
    id: 2,
    category: "Weddings",
    src: "/assets/img/skins-02.webp",
    alt: "Stretch tent with a custom-printed tropical floral skin",
    title: "Tropical Floral Skin",
  },
  {
    id: 3,
    category: "Weddings",
    src: "/assets/img/weddings-03.webp",
    alt: "Wedding celebration under a Pop Pro Tents stretch tent",
    title: "Stretch Tent Wedding 3",
  },
  {
    id: 4,
    category: "Weddings",
    src: "/assets/img/weddings-04.webp",
    alt: "Wedding celebration under a Pop Pro Tents stretch tent",
    title: "Stretch Tent Wedding 4",
  },
  {
    id: 7,
    category: "Weddings",
    src: "/assets/img/weddings-07.webp",
    alt: "Wedding celebration under a Pop Pro Tents stretch tent",
    title: "Stretch Tent Wedding 7",
  },
  {
    id: 8,
    category: "Weddings",
    src: "/assets/img/weddings-08.webp",
    alt: "Wedding celebration under a Pop Pro Tents stretch tent",
    title: "Stretch Tent Wedding 8",
  },
  {
    id: 9,
    category: "Weddings",
    src: "/assets/img/weddings-09.webp",
    alt: "Elegant wedding table setting under a stretch tent with floral centrepieces",
    title: "Elegant Wedding Breakfast",
  },
  {
    id: 10,
    category: "Weddings",
    src: "/assets/img/weddings-10.webp",
    alt: "Wedding celebration under a Pop Pro Tents stretch tent",
    title: "Stretch Tent Wedding 10",
  },
  {
    id: 11,
    category: "Weddings",
    src: "/assets/img/weddings-11.webp",
    alt: "Garden wedding reception under a fairy-lit stretch tent",
    title: "Garden Wedding at Dusk",
  },
  {
    id: 13,
    category: "Weddings",
    src: "/assets/img/weddings-13.webp",
    alt: "Wedding celebration under a Pop Pro Tents stretch tent",
    title: "Stretch Tent Wedding 13",
  },
  {
    id: 14,
    category: "Weddings",
    src: "/assets/img/weddings-14.webp",
    alt: "Wedding celebration under a Pop Pro Tents stretch tent",
    title: "Stretch Tent Wedding 14",
  },
  {
    id: 16,
    category: "Weddings",
    src: "/assets/img/weddings-16.webp",
    alt: "Wedding celebration under a Pop Pro Tents stretch tent",
    title: "Stretch Tent Wedding 16",
  },
  {
    id: 17,
    category: "Weddings",
    src: "/assets/img/weddings-17.webp",
    alt: "Wedding celebration under a Pop Pro Tents stretch tent",
    title: "Stretch Tent Wedding 17",
  },
  {
    id: 18,
    category: "Weddings",
    src: "/assets/img/weddings-18.webp",
    alt: "Wedding celebration under a Pop Pro Tents stretch tent",
    title: "Stretch Tent Wedding 18",
  },

  // ── Festivals & Fairs ──
  {
    id: 19,
    category: "Festivals & Fairs",
    src: "/assets/img/festival-vendor-village-03.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 1",
  },
  {
    id: 20,
    category: "Festivals & Fairs",
    src: "/assets/img/festival-vendor-village-05.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 2",
  },
  {
    id: 21,
    category: "Festivals & Fairs",
    src: "/assets/img/festival-vendor-village-06.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 3",
  },
  {
    id: 22,
    category: "Festivals & Fairs",
    src: "/assets/img/festival-vendor-village-09.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 4",
  },
  {
    id: 23,
    category: "Festivals & Fairs",
    src: "/assets/img/festival-vendor-village-10.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 5",
  },
  {
    id: 24,
    category: "Festivals & Fairs",
    src: "/assets/img/events-04.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 6",
  },
  {
    id: 25,
    category: "Festivals & Fairs",
    src: "/assets/img/festivals-fairs-11.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 7",
  },
  {
    id: 26,
    category: "Festivals & Fairs",
    src: "/assets/img/festival-vendor-village-14.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 8",
  },
  {
    id: 27,
    category: "Festivals & Fairs",
    src: "/assets/img/festival-vendor-village-15.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 9",
  },
  {
    id: 28,
    category: "Festivals & Fairs",
    src: "/assets/img/festival-vendor-village-16.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 10",
  },
  {
    id: 29,
    category: "Festivals & Fairs",
    src: "/assets/img/festival-vendor-village-17.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 11",
  },
  {
    id: 30,
    category: "Festivals & Fairs",
    src: "/assets/img/festival-vendor-village-18.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 12",
  },
  {
    id: 31,
    category: "Festivals & Fairs",
    src: "/assets/img/festival-vendor-village-19.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 13",
  },
  {
    id: 32,
    category: "Festivals & Fairs",
    src: "/assets/img/festival-vendor-village-20.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 14",
  },
  {
    id: 33,
    category: "Festivals & Fairs",
    src: "/assets/img/festival-vendor-village-21.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 15",
  },
  {
    id: 34,
    category: "Festivals & Fairs",
    src: "/assets/img/festivals-fairs-22.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 16",
  },
  {
    id: 35,
    category: "Festivals & Fairs",
    src: "/assets/img/events-06.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 17",
  },
  {
    id: 36,
    category: "Festivals & Fairs",
    src: "/assets/img/events-07.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 18",
  },
  {
    id: 37,
    category: "Festivals & Fairs",
    src: "/assets/img/festival-vendor-village-24.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 19",
  },
  {
    id: 38,
    category: "Festivals & Fairs",
    src: "/assets/img/festival-vendor-village-25.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 20",
  },
  {
    id: 39,
    category: "Festivals & Fairs",
    src: "/assets/img/festival-vendor-village-26.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 21",
  },
  {
    id: 40,
    category: "Festivals & Fairs",
    src: "/assets/img/festivals-fairs-27.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 22",
  },
  {
    id: 41,
    category: "Festivals & Fairs",
    src: "/assets/img/festivals-fairs-28.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 23",
  },
  {
    id: 42,
    category: "Festivals & Fairs",
    src: "/assets/img/festivals-fairs-29.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 24",
  },
  {
    id: 44,
    category: "Festivals & Fairs",
    src: "/assets/img/festival-vendor-village-28.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 26",
  },
  {
    id: 45,
    category: "Festivals & Fairs",
    src: "/assets/img/festival-vendor-village-29.webp",
    alt: "Pop Pro Tents stretch tent at a festival or fair",
    title: "Festival & Fair 27",
  },
  {
    id: 46,
    category: "Festivals & Fairs",
    src: "/assets/img/651bc6ed489f.webp",
    alt: "Artisan market under stretch tent",
    title: "Artisan Craft Market",
  },
  {
    id: 47,
    category: "Festivals & Fairs",
    src: "/assets/img/a09813075774.webp",
    alt: "Outdoor food market under stretch tent",
    title: "Gourmet Food Market",
  },
  {
    id: 48,
    category: "Festivals & Fairs",
    src: "/assets/img/cada58805478.webp",
    alt: "Family summer festival under stretch tent",
    title: "Family Summer Fête",
  },
  {
    id: 49,
    category: "Festivals & Fairs",
    src: "/assets/img/5e44cf75df93.webp",
    alt: "Jazz festival under stretch tent in the evening",
    title: "Jazz & Blues Evening",
  },
  {
    id: 50,
    category: "Festivals & Fairs",
    src: "/assets/img/3c8536d20984.webp",
    alt: "Antique flea market under stretch tent",
    title: "Vintage Flea Market",
  },
  {
    id: 51,
    category: "Festivals & Fairs",
    src: "/assets/img/ff3e677e6f0a.webp",
    alt: "Outdoor book fair under stretch tent",
    title: "Open-Air Book Fair",
  },
  {
    id: 52,
    category: "Festivals & Fairs",
    src: "/assets/img/c3f55ca5f5fb.webp",
    alt: "Beer and wine tasting market under stretch tent",
    title: "Craft Beer & Wine Tasting",
  },
  {
    id: 53,
    category: "Festivals & Fairs",
    src: "/assets/img/2bf586601d94.webp",
    alt: "Art and photography market under stretch tent",
    title: "Art & Photography Fair",
  },

  // ── Brand Activations ──
  {
    id: 54,
    category: "Brand Activations",
    src: "/assets/img/brand-activations-07.webp",
    alt: "Branded stretch tent activation by Pop Pro Tents",
    title: "Brand Activation 1",
  },
  {
    id: 55,
    category: "Brand Activations",
    src: "/assets/img/brand-activations-10.webp",
    alt: "Branded stretch tent activation by Pop Pro Tents",
    title: "Brand Activation 2",
  },
  {
    id: 56,
    category: "Brand Activations",
    src: "/assets/img/brand-activations-09.webp",
    alt: "Branded stretch tent activation by Pop Pro Tents",
    title: "Brand Activation 3",
  },
  {
    id: 57,
    category: "Brand Activations",
    src: "/assets/img/brand-activations-02.webp",
    alt: "Branded stretch tent activation by Pop Pro Tents",
    title: "Brand Activation 4",
  },
  {
    id: 58,
    category: "Brand Activations",
    src: "/assets/img/brand-activations-03.webp",
    alt: "Branded stretch tent activation by Pop Pro Tents",
    title: "Brand Activation 5",
  },
  {
    id: 59,
    category: "Brand Activations",
    src: "/assets/img/brand-activations-05.webp",
    alt: "Branded stretch tent activation by Pop Pro Tents",
    title: "Brand Activation 6",
  },
  {
    id: 60,
    category: "Brand Activations",
    src: "/assets/img/569783cbf383.webp",
    alt: "Corporate networking event under stretch tent",
    title: "Annual Corporate Summit",
  },
  {
    id: 61,
    category: "Brand Activations",
    src: "/assets/img/126d7a3e4add.webp",
    alt: "Business conference under stretch tent",
    title: "Leadership Conference",
  },
  {
    id: 62,
    category: "Brand Activations",
    src: "/assets/img/4bf960680d38.webp",
    alt: "Corporate summer party under stretch tent",
    title: "Company Summer Party",
  },

  // ── Decor ──
  {
    id: 63,
    category: "Decor",
    src: "/assets/img/festival-vendor-village-04.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 1",
  },
  {
    id: 64,
    category: "Decor",
    src: "/assets/img/decor-19.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 2",
  },
  {
    id: 65,
    category: "Decor",
    src: "/assets/img/decor-20.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 3",
  },
  {
    id: 66,
    category: "Decor",
    src: "/assets/img/decor-21.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 4",
  },
  {
    id: 67,
    category: "Decor",
    src: "/assets/img/decor-22.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 5",
  },
  {
    id: 68,
    category: "Decor",
    src: "/assets/img/decor-23.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 6",
  },
  {
    id: 69,
    category: "Decor",
    src: "/assets/img/decor-24.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 7",
  },
  {
    id: 71,
    category: "Decor",
    src: "/assets/img/decor-26.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 9",
  },
  {
    id: 72,
    category: "Decor",
    src: "/assets/img/decor-27.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 10",
  },
  {
    id: 73,
    category: "Decor",
    src: "/assets/img/decor-28.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 11",
  },
  {
    id: 74,
    category: "Decor",
    src: "/assets/img/decor-29.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 12",
  },
  {
    id: 75,
    category: "Decor",
    src: "/assets/img/decor-30.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 13",
  },
  {
    id: 76,
    category: "Decor",
    src: "/assets/img/decor-31.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 14",
  },
  {
    id: 77,
    category: "Decor",
    src: "/assets/img/decor-32.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 15",
  },
  {
    id: 78,
    category: "Decor",
    src: "/assets/img/decor-33.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 16",
  },
  {
    id: 79,
    category: "Decor",
    src: "/assets/img/decor-34.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 17",
  },
  {
    id: 80,
    category: "Decor",
    src: "/assets/img/decor-35.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 18",
  },
  {
    id: 81,
    category: "Decor",
    src: "/assets/img/decor-36.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 19",
  },
  {
    id: 82,
    category: "Decor",
    src: "/assets/img/decor-37.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 20",
  },
  {
    id: 83,
    category: "Decor",
    src: "/assets/img/decor-12.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 21",
  },
  {
    id: 84,
    category: "Decor",
    src: "/assets/img/decor-38.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 22",
  },
  {
    id: 85,
    category: "Decor",
    src: "/assets/img/decor-39.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 23",
  },
  {
    id: 86,
    category: "Decor",
    src: "/assets/img/decor-40.webp",
    alt: "Bespoke stretch tent decor and styling by Pop Pro Tents",
    title: "Bespoke Decor 24",
  },
  {
    id: 87,
    category: "Decor",
    src: "/assets/img/8c08ca7fbc83.webp",
    alt: "Graduation celebration under stretch tent",
    title: "Graduation Celebration",
  },
  {
    id: 88,
    category: "Decor",
    src: "/assets/img/a391e6deefcd.webp",
    alt: "Draped fabric and chandelier bespoke tent decor",
    title: "Ivory & Gold Drape Setup",
  },
  {
    id: 89,
    category: "Decor",
    src: "/assets/img/3d6a1c9f2f89.webp",
    alt: "Rustic barn style bespoke tent decor",
    title: "Rustic Barn Styling",
  },

  // ── Skins and Sidewalls ──
  {
    id: 90,
    category: "Skins and Sidewalls",
    src: "/assets/img/skins-01.webp",
    alt: "Custom-printed stretch tent skin by Pop Pro Tents",
    title: "Printed Skin 1",
  },
  {
    id: 91,
    category: "Skins and Sidewalls",
    src: "/assets/img/skins-02.webp",
    alt: "Stretch tent with a custom-printed tropical floral skin",
    title: "Tropical Floral Skin",
  },
  {
    id: 92,
    category: "Skins and Sidewalls",
    src: "/assets/img/skins-03.webp",
    alt: "Custom-printed stretch tent skin by Pop Pro Tents",
    title: "Printed Skin 3",
  },
  {
    id: 93,
    category: "Skins and Sidewalls",
    src: "/assets/img/skins-04.webp",
    alt: "Custom-printed stretch tent skin by Pop Pro Tents",
    title: "Printed Skin 4",
  },
  {
    id: 94,
    category: "Skins and Sidewalls",
    src: "/assets/img/brand-activations-02.webp",
    alt: "Custom-printed stretch tent skin by Pop Pro Tents",
    title: "Printed Skin 5",
  },
  {
    id: 95,
    category: "Skins and Sidewalls",
    src: "/assets/img/skins-05.webp",
    alt: "Custom-printed stretch tent skin by Pop Pro Tents",
    title: "Printed Skin 6",
  },
  {
    id: 96,
    category: "Skins and Sidewalls",
    src: "/assets/img/f15012e9c6bd.webp",
    alt: "Stretch tent with a custom-printed tropical floral skin",
    title: "Tropical Floral Skin",
  },
  {
    id: 97,
    category: "Skins and Sidewalls",
    src: "/assets/img/fb37793dec38.webp",
    alt: "Stretch tent with a corporate branded custom skin",
    title: "Corporate Exhibition Tent",
  },
  {
    id: 98,
    category: "Skins and Sidewalls",
    src: "/assets/img/ad0b63be293b.webp",
    alt: "Stretch tent with a Christmas themed custom skin",
    title: "Festive Christmas Skin",
  },
  {
    id: 99,
    category: "Skins and Sidewalls",
    src: "/assets/img/9ec458b542cf.webp",
    alt: "Stretch tent with a luxury black and gold custom skin",
    title: "Luxury Brand Skin",
  },

  // ── Glamping ──
  {
    id: 100,
    category: "Glamping",
    src: "/assets/img/glamping-01.webp",
    alt: "Luxury glamping stretch tent setup by Pop Pro Tents",
    title: "Glamping 1",
  },
  {
    id: 101,
    category: "Glamping",
    src: "/assets/img/glamping-03.webp",
    alt: "Luxury glamping stretch tent setup by Pop Pro Tents",
    title: "Glamping 2",
  },
  {
    id: 102,
    category: "Glamping",
    src: "/assets/img/festival-vendor-village-11.webp",
    alt: "Bohemian festival lounge under a stretch tent at night",
    title: "Festival Lounge at Night",
  },
  {
    id: 103,
    category: "Glamping",
    src: "/assets/img/glamping-02.webp",
    alt: "Luxury glamping stretch tent setup by Pop Pro Tents",
    title: "Glamping 4",
  },
  {
    id: 104,
    category: "Glamping",
    src: "/assets/img/glamping-12.webp",
    alt: "Luxury glamping stretch tent setup by Pop Pro Tents",
    title: "Glamping 5",
  },
];
